import React from "react";

const tieDyeImages = [
  {
    src: "/images/tshirt.jpg",
    alt: "Tie-dye T-shirt",
  },
  {
    src: "/images/totebag.jpg",
    alt: "Tie-dye Tote Bag",
  },
  {
    src: "/images/scrunchie.jpg",
    alt: "Tie-dye Scrunchies",
  },
  {
    src: "/images/tshirt2.jpg",
    alt: "Tie-dye T-shirt",
  },
];

const gridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
  gap: "1rem",
};

export default function TieDyeGallery() {
  return (
    <section style={{ padding: "2rem 1rem" }}>
      <div style={gridStyle}>
        {tieDyeImages.map((img, index) => (
          <img
            key={index}
            src={img.src}
            alt={img.alt}
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            }}
          />
        ))}
      </div>
    </section>
  );
}
